const videoSrcDesktop = 'https://cdn.naos.ru/media/landing/bioderma-sensibio-ar-plus/video1-1.mp4';
const videoSrcMobile = 'https://cdn.naos.ru/media/landing/bioderma-sensibio-ar-plus/video1-1.mp4';
const videoPosterDesktop = 'https://cdn.naos.ru/media/landing/bioderma-sensibio-ar-plus/video-preview.jpg';
const videoPosterMobile = 'https://cdn.naos.ru/media/landing/bioderma-sensibio-ar-plus/video-preview_sm.jpg';

$.widget('sensibio.video', {
	_create() {
		this._bind();
	},

	_bind() {
		this._cache();
		this._setPoster();
		this.$element.one('click', () => this._startPlayback());
	},

	_setPoster() {
		this.$element[0].poster = $(window).width() < 768 ? videoPosterMobile : videoPosterDesktop;
	},

	_cache() {
		this.$element = $(this.element);
	},

	_startPlayback() {
		this.initVideo();
		const v = this.$element[0];
		v.controls = true;
		const play = () => v.play().catch(() => {});
		if (v.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) play();
		else v.addEventListener('canplay', play, { once: true });
	},

	initVideo() {
		if ($(window).width() < 768) {
			this.$element.find('source').attr('src', videoSrcMobile);
		} else {
			this.$element.find('source').attr('src', videoSrcDesktop);
		}

		this.$element[0].load();
	}
});